import { type GetServerSideProps, type NextPage } from "next";
import Link from "next/link";
import { Layout } from "~/components/Layout/Layout";
import { EventNames } from "~/mixpanel/EventNames";
import { trackEvent } from "~/mixpanel/trackEvent";

const About: NextPage = () => {
  return (
    <Layout
      title="About Us"
      description="Discover our purpose"
      imgUrl="/img/library-vibe.jpeg"
    >
      <OurMission />
      <OurVision />
      <MoreInfo />
    </Layout>
  );
};

const MoreInfo = () => (
  <>
    <h2>
      More <strong>Information</strong>
    </h2>
    <p>
      If you would like to learn more about the Ibn {`al-Qayyum's`} Islamic
      Public Library of New Jersey, please visit our{" "}
      <Link href="/contact">contact page</Link>.
    </p>
  </>
);

const OurMission = () => (
  <>
    <h2>
      Our <strong>Mission</strong>
    </h2>
    <p>
      Our mission is to establish and maintain the Ibn {`al-Qayyum's`} Islamic
      Public Library of New Jersey as a dedicated institution that serves the
      community by providing authentic Islamic knowledge and resources. We aim
      to do so in adherence to the principles of Tawheed (The Oneness of Allah)
      and in accordance with the teachings of the {`Qur'an`} and the Sunnah of
      the Prophet Muhammad (صلى الله عليه وسلم).
    </p>
    <p>
      At the library, we are committed to preserving and sharing the rich
      Islamic heritage, focusing on the understanding of Islam as practiced by
      the righteous predecessors, including the Sahaabah (Companions of the
      Prophet صلى الله عليه وسلم) and the subsequent generations. Our primary
      goal is to offer access to a comprehensive collection of books,
      manuscripts, and educational materials that align with these principles.
    </p>
    <p>
      In addition to being a valuable resource center, we strive to foster a
      sense of community and provide authentic Islamic education based on the
      Quran and Sunnah. We are dedicated to supporting individuals and families
      in their quest for knowledge and understanding. Our mission also includes
      engaging in outreach and educational programs to promote a correct
      understanding of Islam within our community and beyond.
    </p>
  </>
);

const OurVision = () => (
  <>
    <h2>
      Our <strong>Vision</strong>
    </h2>
    <p>
      Our vision is to create a space that pleases Allah and draws us closer to
      Him. We aim to achieve this by developing and maintaining a library that
      offers a wide range of religious and educational resources, all in harmony
      with the principles of Al-Islam as outlined in the Quran and the Sunnah of
      the Prophet Muhammad (صلى الله عليه وسلم), as understood and implemented
      by his Companions.
    </p>
    <p>
      In pursuing this vision, we are committed to upholding the highest
      standards of character, manners, and conduct. We endeavor to build a sense
      of unity, brotherhood, and inclusivity among Muslims of diverse
      backgrounds, including various races, national origins, linguistic
      backgrounds, and ethnicities. This unity, however, is firmly based on
      authentic Islamic teachings and not on innovations or falsehood.
    </p>
    <p>
      Furthermore, we actively engage with our non-Muslim neighbors, offering
      them opportunities to learn about Islam and have their questions answered.
      Our aim is to foster a genuine and accurate understanding of Al-Islam as
      it was revealed. Through these efforts, we hope to create an environment
      that encourages participation, association, and representation from a wide
      range of individuals and families, all while adhering to the true and
      authentic teachings and ways of Prophet Muhammad (صلى الله عليه وسلم) and
      his Companions.
    </p>
  </>
);
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackEvent(ctx, EventNames.ABOUT_PAGE_VIEWED);
  return { props: {} };
};
export default About;
